import React, { Component, Fragment } from "react";
import { InfoBoard, InfoBoardHelper } from "./InfoBoard";
// import { DH_UNABLE_TO_CHECK_GENERATOR } from "constants";

/**
 * InfoBoard 1 Rullmaterial
 */
class InfoBoard1 extends Component {
    initialValuesLoaded = false;

    handleOrientationChange = event => {
        let { value } = event.target;

        this.setState(
            { printDirection: isNaN(value) ? value : parseFloat(value) },
            this.handleBlur
        );
    };

    handleInput = (name, event) => {
        let { value } = event.target;

        if (
            name == "numDynamicRows" &&
            !isNaN(value) &&
            parseFloat(value) > 10
        ) {
            // Limit to five dynamic rows
            value = 10;
        }

        if (event.target.value == "") {
            this.setState({
                [name]: ""
            });
            return;
        }

        this.setState({
            [name]: isNaN(value) ? value : parseFloat(value)
        });
    };

    handleBlur = () => {
        const standing = 1;
        let area = 0;
        let lapsize = "";
        let usage = 0;
        let circumference = 0;
        let objectsPerRow = 0;

        let {
            height,
            printWidth,
            printHeight,
            overlap,
            printDirection,
            bleed,
            productionMargin,
            mode
        } = this.state;

        let lastRenderedSize =
            this.state.dynRowsTotalAreaWithWaste +
            " " +
            this.state.materialArea;

        let { width: materialWidth } = this.state.originalArticle;

        printWidth = parseFloat(printWidth);
        printHeight = parseFloat(printHeight);
        height = parseFloat(height);
        materialWidth = parseFloat(materialWidth);
        overlap = isNaN(overlap) ? 0 : parseFloat(overlap);
        bleed = isNaN(bleed) ? 0 : parseFloat(bleed);

        if (productionMargin > 0) {
            materialWidth = parseFloat(materialWidth) - parseFloat(productionMargin);
        }

        if (mode == "multi" && !this.initialValuesLoaded) {
            this.recalculateAllDynamicRows();
            return;
        }

        // Stående = 0, liggande = 1
        let wmm = 0;
        let hmm = 0;
        let minw = materialWidth;

        if (printDirection == standing) {
            wmm = parseFloat(printWidth);
            hmm = parseFloat(printHeight);
        } else {
            wmm = parseFloat(printHeight);
            hmm = parseFloat(printWidth);
        }

        var laps = Math.ceil((wmm + bleed * 2) / (minw + bleed * 2));

        jQuery(".js-overlapWarning").hide();

        if (laps > 1) {
            // Add overlap
            wmm += overlap * laps;

            // ...and recalculate number of laps
            let oldLaps = laps;
            laps = Math.ceil(wmm / minw);

            if (laps > oldLaps) {
                let tooWideMM = (wmm / oldLaps - minw) * oldLaps;

                jQuery(".js-overlapWarning")
                    .text(
                        "På grund av överlapp behövs en extravåd för att producera den önskade storleken.\nDetta kan du avhjälpa genom att minska våden med " +
                        tooWideMM +
                        " mm eller mer."
                    )
                    .show();
            }
        }

        // Add bleed
        wmm += bleed * (laps * 2);
        hmm += bleed * 2;

        let w = wmm / 1000;
        let h = hmm / 1000;

        area = parseFloat((w * h).toFixed(4));

        circumference = Math.ceil((w * 2 + h * 2) * 10) / 10;
        let circTotal =
            Math.ceil(((Math.floor(wmm / laps) * 2 + hmm * 2) * laps) / 100) /
            10;

        let materialSize = materialWidth + 'x' + hmm;

        // How many can we fit before we have to start on a new row?
        let usedWidthPercent = 0;
        let joint = Math.ceil(hmm * (laps - 1)) / 1000;

        if (printDirection == standing) {
            let amountPerRow = Math.floor((minw - productionMargin) / printWidth);
            amountPerRow = amountPerRow > 1 ? amountPerRow : 1;

            let printWidthWithOverlapAndBleed = printWidth;

            if (laps > 1) {
                printWidthWithOverlapAndBleed =
                    printWidth + overlap * laps + bleed * laps * 2;
            } else {
                printWidthWithOverlapAndBleed += bleed * 2;
                amountPerRow = Math.floor(minw / printWidthWithOverlapAndBleed);
            }

            usedWidthPercent = Math.round(
                (((printWidthWithOverlapAndBleed * amountPerRow) / minw) *
                    100) /
                laps
            );
        } else {
            let amountPerRow = Math.floor(minw / printHeight);
            
            amountPerRow = amountPerRow > 1 ? amountPerRow : 1;

            let printWidthWithOverlapAndBleed = printHeight;

            if (laps > 1) {
                printWidthWithOverlapAndBleed =
                    printHeight + overlap * laps + bleed * laps * 2;
            } else {
                printWidthWithOverlapAndBleed += bleed * 2;
                amountPerRow = Math.floor(minw / printWidthWithOverlapAndBleed);
            }

            usedWidthPercent = Math.round(
                (((printWidthWithOverlapAndBleed * amountPerRow) / minw) *
                    100) /
                laps
            );
        }

        usage = isNaN(usedWidthPercent) ? "" : usedWidthPercent + "%";

        let circumferenceTotal = circTotal > 0 ? circTotal : 0;

        if (Math.floor(wmm / laps) > 0) {
            lapsize = Math.floor(wmm / laps) + "x" + hmm;
            objectsPerRow =
                Math.floor(minw / wmm) > 1 ? Math.floor(minw / wmm) : 1;
        } else {
            lapsize = "0x" + hmm;
            objectsPerRow = 1;
        }

        let materialArea = 0;

        if (minw > 0) {
            materialArea = ((minw + (productionMargin*2)) / 1000) * h * laps;
        } else {
            materialArea = w * h;
        }

        materialArea = parseFloat(materialArea.toFixed(4));

        this.setState(
            {
                area,
                materialArea,
                laps,
                lapsize,
                overlap,
                usage,
                circumference,
                circumferenceTotal,
                joint,
                objectsPerRow,
                mode,
                lastRenderedSize,
                materialSize
            },
            () => {
                this.updateParent();
            }
        );
    };

    renderDynamicRows = () => {
        let {
            numDynamicRows,
            rows,
            dynRowsTotalCircumference,
            dynRowsTotalArea,
            dynRowsTotalAreaWithWaste
        } = this.state;
        const { isEditable } = this.props;
        const tableHeadings = [
            { name: "Antal", align: "left", width: "5%" },
            { name: "Bas i mm", align: "left", width: "10%" },
            { name: "Höjd i mm", align: "left", width: "5%" },
            { name: "Omkrets lpm", align: "left", width: "5%" },
            { name: "Yta i m2", align: "left", width: "5%" }
        ];

        if (
            "undefined" == typeof numDynamicRows ||
            isNaN(parseInt(numDynamicRows))
        ) {
            return null;
        }

        numDynamicRows = parseInt(numDynamicRows);

        while (rows.length <= 10) {
            rows.push({ amount: 0, width: 0, height: 0 });
        }

        let outputRows = [];
        for (let i = 0; i <= numDynamicRows - 1; i++) {
            outputRows.push(rows[i]);
        }

        return (outputRows.length > 0 &&
            <Fragment>
                <div className="row">
                    <div className="col-12 inputFieldsHolder">
                        {tableHeadings.map(heading => {
                            return (
                                <div
                                    key={heading.name}
                                    className={
                                        "form-group mr-1 limitSize text-" +
                                        heading.align
                                    }
                                >
                                    {heading.name}
                                </div>
                            );
                        })}
                        {isEditable && <div>&nbsp;</div>}
                    </div>
                </div>

                {outputRows.map((row, index) => (
                    <Row
                        index={index}
                        isEditable={isEditable}
                        key={index}
                        onChangeRow={(name, event) =>
                            this.handleChangeDynamicRow(index, name, event)
                        }
                        row={row}
                    />
                ))}

                <div className="row">
                    <div className="col-12 inputFieldsHolder">
                        <div className={"form-group mr-1 limitSize"} />
                        <div className={"form-group mr-1 limitSize"} />
                        <div className={"form-group mr-1 limitSize"} />
                        <div className="form-group mr-1 limitSize">
                            <label>Total omkrets lpm</label>
                            <input
                                className="form-control form-control-sm text-right form-control-hilite js-circumference js-totalCircumference"
                                value={dynRowsTotalCircumference || 0}
                                disabled
                                readOnly
                            />
                        </div>
                        <div className="form-group mr-1 limitSize">
                            <label>
                                Total yta m<sup>2</sup>
                            </label>
                            <input
                                className="form-control form-control-sm text-right form-control-hilite js-orderedAreaM2"
                                value={dynRowsTotalArea || 0}
                                disabled
                                readOnly
                            />
                        </div>
                        <div className="form-group mr-1 limitSize">
                            <label>
                                Total m<sup>2</sup> inkl spill
                            </label>
                            <input
                                className="form-control form-control-sm text-right form-control-hilite js-orderedAreaM2WithWaste"
                                value={dynRowsTotalAreaWithWaste || 0}
                                disabled
                                readOnly
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    };

    recalculateAllDynamicRows = () => {
        const { rows } = this.state;
        for (let i = 0; i < rows.length; i++) {
            rows[i] = this.calculateDynamicRowFields(rows[i]);
        }

        this.setState({ rows }, () => this.calculateDynamicRowsTotal());
    };

    handleWasteChange = (name, event) => {
        let { value } = event.target;

        this.setState(
            {
                [name]: isNaN(value) || value == "" ? "" : parseFloat(value)
            },
            () => {
                this.recalculateAllDynamicRows();
            }
        );
    };

    calculateDynamicRowsTotal = () => {
        const { rows, numDynamicRows } = this.state;
        const waste = isNaN(parseFloat(this.state.waste))
            ? 0
            : parseFloat(this.state.waste);
        const wasteMultiplier = isNaN(parseFloat(waste))
            ? 1
            : 1 + parseFloat(waste) / 100;
        let dynRowsTotalCircumference = 0;
        let dynRowsTotalArea = 0;

        for (let i = 0; i < numDynamicRows; i++) {
            dynRowsTotalCircumference += parseFloat(rows[i]["circumference"]);
            dynRowsTotalArea += parseFloat(rows[i]["area"]);
        }

        if (isNaN(dynRowsTotalCircumference) || isNaN(dynRowsTotalArea)) return;

        dynRowsTotalCircumference = parseFloat(
            dynRowsTotalCircumference.toFixed(4)
        );
        dynRowsTotalArea = parseFloat(dynRowsTotalArea.toFixed(4));

        let dynRowsTotalAreaWithWaste = parseFloat(
            (dynRowsTotalArea * wasteMultiplier).toFixed(4)
        );

        this.setState(
            {
                dynRowsTotalCircumference,
                dynRowsTotalArea,
                dynRowsTotalAreaWithWaste
            },
            () => {
                this.updateParent();
            }
        );
    };

    updateParent = () => {
        let { onChange } = this.props;
        const { data } = this.props;
        const { id } = data;
        const {
            mode,
            quantity,
            dynRowsTotalAreaWithWaste,
            materialArea,
            objectsPerRow,
            lastRenderedSize,
            forceRecalculate
        } = this.state;

        if ("function" !== typeof onChange) {
            console.error("Missing function onChange");
            return false;
        }

        if (!this.initialValuesLoaded) {
            onChange(id, "quantity", quantity);
            this.initialValuesLoaded = true;
        } else {
            if (
                lastRenderedSize !=
                dynRowsTotalAreaWithWaste + " " + materialArea || forceRecalculate
            ) {
                if (mode == "multi") {
                    onChange(
                        id,
                        "quantity",
                        dynRowsTotalAreaWithWaste,
                        "infoboard"
                    );
                    onChange(id, "clear_dont_recalculate_flag");
                } else {
                    onChange(id, "quantity", materialArea);
                    onChange(id, "clear_dont_recalculate_flag");
                }
            }
        }

        onChange(id, "height", "-");
        onChange(id, "objectsPerRow", objectsPerRow);
    };

    handleChangeDynamicRow = (index, name, event) => {
        const { rows, numDynamicRows } = this.state;
        let thisRow = { ...rows[index] };

        thisRow[name] = event.target.value;

        rows[index] = this.calculateDynamicRowFields(thisRow);

        this.setState({ rows }, () => {
            this.calculateDynamicRowsTotal();
        });
    };

    calculateDynamicRowFields = originalRow => {
        const row = { ...originalRow };
        const width = isNaN(parseFloat(row["width"]))
            ? 0
            : parseFloat(row["width"]);
        const height = isNaN(parseFloat(row["height"]))
            ? 0
            : parseFloat(row["height"]);
        const amount = isNaN(parseFloat(row["amount"]))
            ? 0
            : parseFloat(row["amount"]);

        if (width * height * amount == 0) {
            row.circumference = 0;
            row.area = 0;
        } else {
            row.circumference = parseFloat(
                (((width * 2 + height * 2) / 1000) * amount).toFixed(4)
            );
            row.area = parseFloat(
                ((width * height * amount) / 1000000).toFixed(4)
            );
        }

        return row;
    };

    getPopulatedData() {
        const { data, extendedData, globalSettings } = this.props;

        if (extendedData.printHeight) {
            let printHeight = parseFloat(extendedData.printHeight);
            if (isNaN(printHeight)) {
                printHeight = 0;
            }
            data.printHeight = printHeight;
        } else {
            data.printHeight = 0;
        }

        if (extendedData.bleed) {
            let bleed = parseInt(extendedData.bleed);
            if (isNaN(bleed)) {
                bleed = globalSettings.bleed;
            }
            data.bleed = bleed;
        } else {
            data.bleed = globalSettings.bleed;
        }

        if (extendedData.productionMargin) {
            let productionMargin = parseInt(extendedData.productionMargin);
            if (isNaN(productionMargin)) {
                if (this.props.isEditable) {
                    productionMargin = globalSettings.infoboard1DefaultProductionMargin;
                } else {
                    productionMargin = 0;
                }
                
            }
            data.productionMargin = productionMargin;
        } else {
            if (this.props.isEditable) {
                data.productionMargin = globalSettings.infoboard1DefaultProductionMargin;
            } else {
                data.productionMargin = 0;
            }
        }

        if (extendedData.numDynamicRows) {
            let numDynamicRows = parseInt(extendedData.numDynamicRows);
            if (isNaN(numDynamicRows)) {
                numDynamicRows = 0;
            }
            data.numDynamicRows = numDynamicRows;
        } else {
            data.numDynamicRows = 1;
        }

        if (extendedData.waste) {
            let waste = parseInt(extendedData.waste);
            if (isNaN(waste)) {
                waste = globalSettings.waste;
            }
            data.waste = waste;
        } else {
            data.waste = globalSettings.waste;
        }

        if (extendedData.overlap) {
            let overlap = parseInt(extendedData.overlap);
            if (isNaN(overlap)) {
                overlap = globalSettings.overlap;
            }
            data.overlap = overlap;
        } else {
            data.overlap = globalSettings.overlap;
        }

        if (extendedData.printDirection) {
            data.printDirection =
                extendedData.printDirection === "1" ? "1" : "0";
            if (data.numDynamicRows) {
                data.mode = data.printDirection === "1" ? "single" : "multi";
            } else {
                data.mode = "single";
            }
        } else {
            data.printDirection = 0;
            data.mode = "single";
        }

        if (extendedData.printWidth) {
            let printWidth = parseFloat(extendedData.printWidth);
            if (isNaN(printWidth)) {
                printWidth = 0;
            }
            data.printWidth = printWidth;
        } else {
            data.printWidth = 0;
        }

        if (data.printWidth  > 0 && data.printHeight > 0) {
            data.mode = "single";
        } else {
            data.mode = "multi";
        }

        // Always default to single view if new cost estimate row was added
        if (Object.keys(extendedData).length === 0) {
            data.mode = "single";
        }

        data.rows =
            extendedData.rows && extendedData.rows.length > 0
                ? extendedData.rows
                : [];

        return data;
    }

    setMode = (mode) => {
        this.setState(
            {
                mode,
                forceRecalculate: true
            },
            () => {
                this.renderFields();
                this.handleBlur();
            }
        );
    } 

    renderFields = () => {
        const { mode } = this.state;

        if ("single" === mode) {
            return this.renderSingleObjectFields();
        } else if ("multi" === mode) {
            return (
                <Fragment>
                    {this.renderMultiObjectFields()}
                </Fragment>
            );
        }
    };

    renderSingleObjectFields = () => {
        const {
            printDirection,
            printHeight,
            overlap,
            printWidth,
            area,
            materialArea,
            laps,
            lapsize,
            usage,
            circumference,
            circumferenceTotal,
            joint,
            objectsPerRow,
            bleed,
            productionMargin,
            materialSize
        } = this.state;

        const { isEditable } = this.props;
        const showHelpTexts = this.props.globalSettings.showHelpTexts == 1;

        const rotationList = [
            {
                option: "Liggande",
                value: "0"
            },
            {
                option: "Stående",
                value: "1"
            }
        ];

        return (
            <Fragment>
                <div className="row">
                    <div className="col-9">
                        <div className="row">
                            {isEditable && (
                            <div className="col-12 mb-4">
                                <label>Läge:</label>
                                <button className="btn btn--smallText ml-2" onClick={(e) => {e.preventDefault();}}>Storlek</button>
                                <button className="btn btn--smallText btn--smallText--outline ml-2" onClick={(e) => {e.preventDefault(); this.setMode('multi');}}>Spill</button>
                            </div>
                            )}
                            <div className="col-12 inputFieldsHolder">
                                <div className="form-group mr-1">
                                    <label>Rotation</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderSelect(rotationList, {
                                            name: "printDirection",
                                            onChange: event =>
                                                this.handleOrientationChange(event),
                                            value: printDirection,
                                            style: { width: "100px" }
                                        })}
                                    {!isEditable &&
                                        rotationList.map((rotation, index) =>
                                            rotation.value == printDirection ? (
                                                <input
                                                    className="form-control form-control-sm"
                                                    key={index}
                                                    readOnly
                                                    value={rotation.option}
                                                />
                                            ) : (
                                                    ""
                                                )
                                        )}
                                </div>
                                <div className="form-group mr-1">
                                    <label>Bas i mm</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "printWidth",
                                            onChange: event =>
                                                this.handleInput("printWidth", event),
                                            onBlur: () => this.handleBlur(),
                                            value: printWidth,
                                            className:
                                                "form-control form-control-sm text-right"
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            readOnly
                                            value={printWidth}
                                        />
                                    )}
                                </div>
                                <div className="form-group mr-1">
                                    <label>Höjd i mm</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "printHeight",
                                            onChange: event =>
                                                this.handleInput("printHeight", event),
                                            onBlur: () => this.handleBlur(),
                                            value: printHeight,
                                            className:
                                                "form-control form-control-sm text-right"
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            disabled
                                            readOnly
                                            value={printHeight}
                                        />
                                    )}
                                </div>
                                <div className="form-group mr-1">
                                    <label>Överlapp</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "overlap",
                                            onChange: event =>
                                                this.handleInput("overlap", event),
                                            onBlur: () => this.handleBlur(),
                                            value: overlap,
                                            className:
                                                "form-control form-control-sm text-right"
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            disabled
                                            readOnly
                                            value={overlap}
                                        />
                                    )}
                                </div>
                                <div className="form-group mr-1">
                                    <label>Utfall</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "bleed",
                                            onChange: event =>
                                                this.handleInput("bleed", event),
                                            onBlur: () => this.handleBlur(),
                                            value: bleed,
                                            className:
                                                "form-control form-control-sm text-right"
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            disabled
                                            readOnly
                                            value={bleed}
                                        />
                                    )}
                                </div>
                                <div className="form-group mr-1">
                                    <label>
                                        Beställd yta m<sup>2</sup>
                                    </label>
                                    <input
                                        className="form-control form-control-sm form-control-hilite text-right js-orderedAreaM2"
                                        value={area || 0}
                                        disabled
                                        readOnly
                                    />
                                </div>
                                <div className="form-group mr-1">
                                    <label>
                                        Materialets yta m<sup>2</sup>
                                    </label>
                                    <input
                                        className="form-control form-control-sm form-control-hilite text-right js-materialAreaM2"
                                        value={materialArea || 0}
                                        disabled
                                        readOnly
                                    />
                                </div>
                                <div className="form-group mr-1">
                                    <label>Marginal</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "productionMargin",
                                            onChange: event =>
                                                this.handleInput("productionMargin", event),
                                            onBlur: () => this.handleBlur(),
                                            value: productionMargin,
                                            className:
                                                "form-control form-control-sm text-right"
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            disabled
                                            readOnly
                                            value={productionMargin}
                                        />
                                    )}
                                </div>
                                <div className="form-group mr-1">
                                    <label>Materialets format</label>
                                    {<input
                                            className="form-control form-control-sm form-control-hilite text-right"
                                            disabled
                                            readOnly
                                            value={materialSize}
                                        />}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 inputFieldsHolder">
                                <div className="form-group mr-1">
                                    <label>Antal våder</label>
                                    {InfoBoardHelper.renderReadOnlyText({
                                        name: "laps",
                                        value: laps || 0,
                                        className:
                                            "form-control form-control-sm text-right"
                                    })}
                                </div>

                                <div className="form-group mr-1">
                                    <label>Vådstorlek mm</label>
                                    {InfoBoardHelper.renderReadOnlyText({
                                        name: "lapSize",
                                        value: lapsize || 0,
                                        className:
                                            "form-control form-control-sm text-right"
                                    })}
                                </div>
                                <div className="form-group mr-1">
                                    <label>Förbrukning %</label>
                                    <input
                                        className="form-control form-control-sm text-right"
                                        value={usage || 0}
                                        disabled
                                        readOnly
                                    />
                                </div>
                                <div className="form-group mr-1">
                                    <label>Upplägg</label>
                                    {InfoBoardHelper.renderReadOnlyText({
                                        name: "objectsPerRow",
                                        value: objectsPerRow || 0,
                                        className:
                                            "form-control form-control-sm form-control-hilite text-right js-objectsPerRow"
                                    })}
                                </div>
                                <div className="form-group mr-1">
                                    <label>Omkrets lpm</label>
                                    <input
                                        className="form-control form-control-sm form-control-hilite text-right js-circumference"
                                        value={circumference || 0}
                                        disabled
                                        readOnly
                                    />
                                </div>
                                <div className="form-group mr-1">
                                    <label>Total omkrets lpm</label>
                                    <input
                                        className="form-control form-control-sm form-control-hilite text-right js-totalCircumference"
                                        value={circumferenceTotal || 0}
                                        disabled
                                        readOnly
                                    />
                                </div>
                                <div className="form-group mr-1">
                                    <label>Skarv</label>
                                    <input
                                        className="form-control form-control-sm form-control-hilite text-right js-seam"
                                        value={joint || 0}
                                        disabled
                                        readOnly
                                    />
                                </div>
                                {InfoBoardHelper.renderHiddenInput({
                                    name: "infoboardType",
                                    value: 1
                                })}
                            </div>
                        </div>
                    </div>
                    <div className={(showHelpTexts ? "col-3" : "d-none")}>
                        <div className="helperTextBlock">
                            <p><b>Rullmaterial - Storlek</b><br />
                            Välj produktionsstorlek och rotera för att undvika skarv eller minska spill.
                            Kontrollera våder, överlapp, utfall och produktionsmarginal. Hela rullbredden debiteras i kalkylen.</p>
                            <p>Artiklar som du vill koppla dras in med flyttknappen till höger och kopplade artiklar blir gröna.</p>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    };

    renderMultiObjectFields = () => {
        const { numDynamicRows, waste } = this.state;
        const { isEditable } = this.props;
        const showHelpTexts = this.props.globalSettings.showHelpTexts == 1;

        return (
            <Fragment>
                <div className="row">
                    <div className="col-9">
                        <div className="row">
                            {isEditable && (
                            <div className="col-12 mb-4">
                                <label>Läge:</label>
                                <button className="btn btn--smallText btn--smallText--outline ml-2" onClick={(e) => {e.preventDefault(); this.setMode('single');}}>Storlek</button>
                                <button className="btn btn--smallText ml-2" onClick={(e) => {e.preventDefault();}}>Spill</button>
                            </div>
                            )}
                            <div className="col-12 inputFieldsHolder">
                                <div className="form-group mr-1 limitSize">
                                    <label>Antal rader</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "numDynamicRows",
                                            onChange: event =>
                                                this.handleInput(
                                                    "numDynamicRows",
                                                    event
                                                ),
                                            onBlur: () => this.handleBlur(),
                                            value: numDynamicRows
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            readOnly
                                            value={numDynamicRows}
                                        />
                                    )}
                                </div>
                                <div className="form-group mr-1 limitSize">
                                    <label>Spill i %</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "waste",
                                            onChange: event =>
                                                this.handleWasteChange("waste", event),
                                            value: waste
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            readOnly
                                            value={waste}
                                        />
                                    )}
                                </div>

                                {InfoBoardHelper.renderHiddenInput({
                                    name: "infoboardType",
                                    value: 1
                                })}
                            </div>
                        </div>
                        {this.renderDynamicRows()}
                    </div>
                    <div className={(showHelpTexts ? "col-3" : "d-none")}>
                        <div className="helperTextBlock">
                            <p>
                                <b>Rullmaterial - Spill</b><br />
                                Välj antal rader för olika storlekar du vill ha i produktionen samt spillpåslag i procent.
                                Totalen beräknas som en i kvantitetsprisberäkningen nedan. Kalkylen tar inte hänsyn till bredden.
                            </p>
                            <p>Artiklar som du vill koppla dras in med flyttknappen till höger och kopplade artiklar blir gröna.
                            </p>
                        </div>
                    </div>
                </div>
            </Fragment >
        );
    };

    constructor(props) {
        super(props);
        // Populate with previously saved data
        const data = this.getPopulatedData();
        this.state = data;
    }

    componentDidMount() {
        this.handleBlur();
    }

    render() {
        const { sortIndex } = this.props;
        InfoBoardHelper.sortIndex = sortIndex;

        return <InfoBoard>{this.renderFields()}</InfoBoard>;
    }
}

class Row extends Component {
    render() {
        const { index, isEditable, row } = this.props;

        return (
            <Fragment>
                <div className="row">
                    <div className="col-12 inputFieldsHolder">
                        <div className="form-group mr-1 limitSize">
                            {isEditable &&
                                InfoBoardHelper.renderTextInput({
                                    name: "[rows][" + index + "][amount]",
                                    onChange: event =>
                                        this.props.onChangeRow("amount", event),
                                    value: row.amount
                                })}
                            {!isEditable && (
                                <input
                                    className="form-control form-control-sm text-right"
                                    readOnly
                                    value={row.amount}
                                />
                            )}
                        </div>
                        <div className="form-group mr-1 limitSize">
                            {isEditable &&
                                InfoBoardHelper.renderTextInput({
                                    name: "[rows][" + index + "][width]",
                                    onChange: event =>
                                        this.props.onChangeRow("width", event),
                                    value: row.width
                                })}
                            {!isEditable && (
                                <input
                                    className="form-control form-control-sm text-right"
                                    readOnly
                                    value={row.width}
                                />
                            )}
                        </div>
                        <div className="form-group mr-1 limitSize">
                            {isEditable &&
                                InfoBoardHelper.renderTextInput({
                                    name: "[rows][" + index + "][height]",
                                    onChange: event =>
                                        this.props.onChangeRow("height", event),
                                    value: row.height
                                })}
                            {!isEditable && (
                                <input
                                    className="form-control form-control-sm text-right"
                                    readOnly
                                    value={row.height}
                                />
                            )}
                        </div>
                        <div className="form-group mr-1 limitSize">
                            <input
                                className="form-control form-control-sm text-right"
                                name={"[rows][" + index + "][circumference]"}
                                value={row.circumference || 0}
                                disabled
                            />
                        </div>
                        <div className="form-group mr-1 limitSize">
                            <input
                                className="form-control form-control-sm text-right"
                                name={"[rows][" + index + "][area]"}
                                value={row.area || 0}
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default InfoBoard1;
